export const getImagePath = (fileName: string) => './images/' + fileName;
